import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentService } from '@galaxy/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import {
  POSTHOG_API_KEY,
  POSTHOG_PROJECT_NAME,
  POSTHOG_PROJECT_UUID,
} from './analytics/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  constructor(
    private environmentService: EnvironmentService,
    private analytics: ProductAnalyticsService,
  ) {
    this.analytics.initialize({
      environment: this.environmentService.getEnvironment(),
      projectUUID: POSTHOG_PROJECT_UUID,
      postHogID: POSTHOG_API_KEY,
      projectName: POSTHOG_PROJECT_NAME,
    });
  }
}
